import React from "react";
import SocialMediaIcons from "./SocialMediaIcons";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="portfolio-container footer-inner">
        <div>
          <strong>Paul Carter</strong>
          <p className="section-copy" style={{ marginTop: "0.35rem", fontSize: "0.95rem" }}>
            Software developer building polished, responsive web experiences.
          </p>
          <ul className="footer-contact-list">
            <li><a href="tel:+17575321501">(757) 532-1501</a></li>
            <li><a href="mailto:carterpaul1@yahoo.com">carterpaul1@yahoo.com</a></li>
          </ul>
        </div>
        <SocialMediaIcons size="large" />
      </div>
    </footer>
  );
};

export default Footer;
